import { useQuery } from "@tanstack/react-query";

// const url = process.env.REACT_APP_URL_DIR + "user";

export function GetInsumos() {
   const token = localStorage.getItem("token");
   const urlProd = process.env.REACT_APP_URL_DIR + "Insumo";

   const { data } =  useQuery({
      queryKey: ["Insumo"],
      queryFn: async () => {
         const res = await fetch(urlProd, {
            headers: {
               Authorization: `Bearer ${token}`,
            },
         });

         if (!res.ok) {
            throw new Error(`Error ${res.status}: ${res.statusText}`);
         }

         return res.json();
      },
   });
   return data;
}

export default GetInsumos;
